/**
 * Claves de React Query del sistema de permisos.
 *
 * Todas cuelgan de `["rbac"]` para poder invalidarlas o purgarlas de una sola
 * vez: al cerrar sesión se eliminan enteras, porque en una máquina compartida
 * la siguiente persona heredaría la caché de la anterior.
 */
export const rbacKeys = {
  all: ["rbac"] as const,
  roles: () => [...rbacKeys.all, "roles"] as const,
  assignments: () => [...rbacKeys.all, "assignments"] as const,
  assignment: (uid: string | null) => [...rbacKeys.all, "assignment", uid] as const,
  profile: (uid: string | null) => [...rbacKeys.all, "profile", uid] as const,
};

/** Cuánto se consideran frescos los datos de permisos. */
export const RBAC_STALE_TIME = 5 * 60 * 1000;
